export default __webpack_public_path__ + "static/media/airlockz-wht-banner-2.2e1a33c2.jpg";